<script setup lang="ts">
import LoadingGif from "@/assets/loading-800.gif";
</script>
<template>
  <img
    :src="LoadingGif"
    class="w-full h-full max-w-24 max-h-24"
    alt="loading"
  />
</template>
